import type { DocumentDescription } from './DocumentDescription';

export type Document = {
  readonly id: string;
  readonly description: DocumentDescription | string;
  readonly status: DocumentStatus;
  readonly uploadedFile?: UploadedDocument;
  readonly rejectedReason: string;
  //TODO "v2/documents" task: add "documentType" (or documentRequirements) field which will have a value of "DocumentId"
};

export type ToDeliverDocument = Document;
export type DoneDocument = Document;
export type RejectedDocument = Document;

export type UploadedDocument = {
  readonly fileName: string;
  readonly extension: DocumentFileType;
  readonly isDeletable: boolean;
  readonly fileSize: number;
  readonly uploadDate: string;
  readonly activeDocumentId?: string;
};

export enum DocumentStatus {
  toDeliver = 'ToDeliver',
  done = 'Done',
  rejected = 'Rejected',
  none = 'None',
  failed = 'Failed'
}

export enum DocumentFileType {
  pdf = 'pdf',
  jpg = 'jpg',
  jpeg = 'jpeg'
}

export enum DocumentListContext {
  UploadList = 'UploadList',
  Renteaanbod = 'Renteaanbod',
  OfferteDownload = 'OfferteDownload',
  OfferteUpload = 'OfferteUpload',
  OfferteDone = 'OfferteDone',
  All = 'All'
}
